var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseMyFrame6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8045 8.75V11.074H14.5315V8.75C14.5315 7.10406 14.8485 6.16439 15.3618 5.61681C15.8601 5.08538 16.7794 4.676 18.6055 4.676H24.7305C26.5565 4.676 27.4759 5.08538 27.9741 5.61681C28.4874 6.16439 28.8045 7.10406 28.8045 8.75Z",
    stroke: "white",
    strokeWidth: 2.352,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.492 27.426V33.25C27.492 34.8187 27.1006 35.7793 26.5239 36.3559C25.9472 36.9326 24.9867 37.324 23.418 37.324H19.918C18.3492 37.324 17.3887 36.9326 16.812 36.3559C16.2354 35.7793 15.844 34.8187 15.844 33.25V27.426H27.492Z",
    stroke: "white",
    strokeWidth: 2.352,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.492 31.5V32.676H28.668H32.168C34.0992 32.676 35.7637 32.1924 36.937 31.0191C38.1104 29.8457 38.594 28.1813 38.594 26.25V17.5C38.594 15.5687 38.1104 13.9043 36.937 12.7309C35.7637 11.5576 34.0992 11.074 32.168 11.074H11.168C9.23669 11.074 7.57224 11.5576 6.39891 12.7309C5.22558 13.9043 4.74197 15.5687 4.74197 17.5V26.25C4.74197 28.1813 5.22558 29.8457 6.39891 31.0191C7.57224 32.1924 9.23669 32.676 11.168 32.676H14.668H15.844V31.5V27.426H27.492V31.5Z",
    stroke: "white",
    strokeWidth: 2.352,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.418 26.25H28.3005H12.918",
    stroke: "white",
    strokeWidth: 2.352,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.918 19.25H18.168",
    stroke: "white",
    strokeWidth: 2.352,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseMyFrame6);
export default __webpack_public_path__ + "static/media/use_my_frame6.5b8a579abe5f459ab1c5f2590232bc99.svg";
export { ForwardRef as ReactComponent };